import { Box, Text } from "grommet";
import React from "react";

const LoadingSign = () => {
    return (
        <Box align="center" justify="center" width="full" height="full">
            <Text size="14px"> 자료 불러오는 중 ...</Text>
        </Box>
    );
};

export default LoadingSign;